import React, { useContext, useEffect, useState } from "react"
import * as ReactDOMClient from 'react-dom/client';
import ScriptTag from 'react-script-tag';
import ReactDOM from "react-dom";
import BuilderContext, {BuilderProvider} from "../../context/BuilderContext";
import TranslationContext, {TranslationProvider} from "../../context/TranslationContext";
import UserContext, {UserProvider} from "../../context/UserContext";
import {LangChangerCopy} from "../common/LangChanger";
import ButtonsAction from "../Authentication/AuthContainer/ButtonsAction";
import AuthorizeAction from "../Authorization/AuthorizeAction"


import { BE_ADDR } from "../../api/host";
import EsiaAuth from "../Authentication/AuthContainer/ButtonsAction/EsiaAction";
import HotspotContext, {HotspotProvider} from "../../context/HotspotContext";
import ErrorDescription from "../common/Errors";
import { ExtraActionButBlock } from "../Authentication/AuthContainer/ButtonsAction/ExtraAction";
import {  CheckOptionON, ContractOptionMask } from "../../api/helper";


const Template = () => {
    let builder = useContext(BuilderContext)
    let user = useContext(UserContext)
    let translations = useContext(TranslationContext)
    let hotspot = useContext(HotspotContext)

    // переключение от формы выбора авторизации к форме действий 
    const [authChallengeRender, setAuthChallengeRender ] = useState(false)
    // запуск сценария логина пользователя на хотспот 
    const [loginChallengeRender, setLoginChallengeRender ] = useState(false)

    // активация форм для действий 
    const [authCall499, setAuthCall499] = useState(false)
    const [authSms, setAuthSms] = useState(false)
    const [authCall800, setAuthCall800] = useState(false)
    const [authPin, setAuthPin] = useState(false)
    const [authMobileId, setAuthMobileId] = useState(false)
    const [authVoip, setAuthVoip] = useState(false)
    const [externalAuth, setExternalAuth] = useState(false)

    // состояние для сохранения выбранного пользователем конфига 
    const [external, setExternalUnit] = useState({})
    // const [authGos, setAuthGos] = useState(false)


    const handlerBackBtn = () => {
        setAuthChallengeRender(false)
        setAuthCall499(false)
        setAuthCall800(false)
        setAuthSms(false)
        setAuthPin(false)
        setAuthVoip(false)
        setAuthMobileId(false)
        setExternalAuth(false)
        setLoginChallengeRender(false)
    } 

    const clickButtonAuthTypeSelect = (setAuth) => {
        return () => {
            setAuthChallengeRender(true)
            setAuth(true)
        }
    }

    const handlerExtraAuthStart = () => {
        setExternalAuth(true);
        setAuthChallengeRender(true)
    }

    const clickButtonLogin = () => {
        setLoginChallengeRender(true)
    }

    // langs
    useEffect(() => {
        const lngChangerMap = document.getElementsByClassName("s-lng-changer")
        const footerLink = document.getElementById("footer_link")
        if (translations.language === "ru") {
            footerLink.setAttribute("href", "./ru.pdf")
        } else {
            footerLink.setAttribute("href", "./en.pdf")
        }
        

        if (lngChangerMap.length > 0) {
            for (let i = 0; i < lngChangerMap.length; i++) {
                // read data-changelng and create Component with key
                ReactDOM.render(
                    <TranslationProvider value ={translations} >
                        <LangChangerCopy setLangKey={`${lngChangerMap[i].dataset.changelng}`}
                            textFormat = {lngChangerMap[i].innerText}
                        />
                    </TranslationProvider>,
                lngChangerMap[i]);
            }
        }

    }, [user.unknown_device, translations])

    // trigger show/hide button or actions on authentication page
    useEffect(() => {
        const ident = document.getElementById('ident')
        const auth = document.getElementById('auth_actions')
        if (authChallengeRender) {
            ident && ident.classList.add("d-none")
            auth && auth.classList.remove("d-none")
        } else {
            ident && ident.classList.remove("d-none")
            auth && auth.classList.add("d-none")
        }
    },[authChallengeRender])

    useEffect(()=>{
        if (!!user.error) {
            ReactDOM.render(
                <TranslationProvider value ={translations} ><ErrorDescription error={user.error} /></TranslationProvider>
            , document.getElementById("content"))
        }
    },[user.error, translations])
 
    // render authorize actions
    useEffect(() => {
        if (!document.getElementById("welcome_actions")) {
            return
        }
        !user.unknown_device && ReactDOM.render(
            <TranslationProvider value ={translations} >
                <BuilderProvider value = {builder}>
                    <UserProvider value = {user}>
                        <HotspotProvider value = {hotspot}>
                        {
                            loginChallengeRender && <AuthorizeAction 
                                handlerBackBtn = {handlerBackBtn}
                            />
                        }
                        </HotspotProvider>
                    </UserProvider>
                </BuilderProvider>
            </TranslationProvider>
        
        , document.getElementById("welcome_actions"))
    }, [user.unknown_device, user.adBreak ,loginChallengeRender, builder, hotspot, translations, user])

    const toogleAuthState = (status) => {
        user.setUnknownDevice(!status)
    }
    // render authentication actions
    useEffect(() => {   
        if (!document.getElementById("auth_actions")) {
            return
        } 
        user.unknown_device && ReactDOM.render(
            <TranslationProvider value ={translations} >
                <BuilderProvider value = {builder}>
                    <UserProvider value = {user}>
                        {
                            authChallengeRender && <ButtonsAction 
                                setAccess = {toogleAuthState}
                                external={external}
                                callBtnShow = {authCall499}
                                smsBtnShow = {authSms}
                                call800BtnShow = {authCall800}
                                pinBtnShow = {authPin}
                                midBtnShow = {authMobileId}
                                voipBtnShow = {authVoip}
                                extraBtnShow={externalAuth}
                                handlerBackBtn = {handlerBackBtn}
                            />
                        }
                    </UserProvider>
                </BuilderProvider>
            </TranslationProvider>
        
        , document.getElementById("auth_actions"))

    }, [user.unknown_device, authCall499, authSms, authCall800, authPin, authMobileId, authVoip, authChallengeRender, user.setUnknownDevice, translations, user, builder])
    

    // triggers show/hide authentication menu
    useEffect(() => {
        const call499 = document.getElementById('get_call499')
        const call800 = document.getElementById('get_call800')
        const sms = document.getElementById('get_sms')
        const mob_id = document.getElementById('get_mob_id')
        const pin = document.getElementById('get_pin')
        const voip = document.getElementById('get_voip')

        const buttonAddEvent = (nodeButton, authMeta, handler) => {
            debugger
            nodeButton.addEventListener("click",  clickButtonAuthTypeSelect(handler))
            !CheckOptionON(builder.options, authMeta)  && nodeButton.classList.add("d-none")
        } 

        if (builder.interactive) {
            if (call499) {
                buttonAddEvent(call499, ContractOptionMask.AuthCall499, setAuthCall499)
            }
            if (sms) {
                buttonAddEvent(sms, ContractOptionMask.AuthSMS, setAuthSms)
            }
            if (mob_id) {
                buttonAddEvent(mob_id, ContractOptionMask.AuthMobileID, setAuthMobileId)
            }
            if (pin) {
                buttonAddEvent(pin, ContractOptionMask.AuthPIN, setAuthPin)
            }
            if (call800) {
                buttonAddEvent(call800, ContractOptionMask.AuthCall800, setAuthCall800)
            }
            if (voip) {
                buttonAddEvent(voip, ContractOptionMask.AuthVoip, setAuthVoip)
            }
            // if (api) {
            //     buttonAddEvent(api, ContractOptionMask.AuthExternalAPI, setAuthApi)
            // }
        }

    }, [])

  

    useEffect(()=>{
        const api = document.getElementById('get_external')
    
        if (api && CheckOptionON(builder.options,  ContractOptionMask.AuthExternalAPI)) {
            const root = ReactDOMClient.createRoot(api)
            
            // console.log("hellp builder",builder)
            root.render(
            <TranslationProvider value = {translations}>
                <BuilderProvider value = {builder}>
                    <UserProvider value = {user}>
                        {
                        <ExtraActionButBlock 
                            start = {handlerExtraAuthStart}
                            setExternalUnit={setExternalUnit}
                            interactive={builder.interactive} 
                            external={builder.external}
                            />
                        }
                    
                    </UserProvider>
                </BuilderProvider>
            </TranslationProvider>, 
            )
        }
    },[translations, builder, user, externalAuth, authChallengeRender])

    useEffect(() => {
        const esia = document.getElementById('go_esia')
        if (esia) {
            ReactDOM.render(<TranslationProvider value = {translations}><EsiaAuth /></TranslationProvider>, esia)

            if (builder.profile.esia) {
                esia.classList.add("d-none")
            }
        }
    }, [translations])

    useEffect(() => {
        const authBtn = document.getElementById('get_auth')
        if (authBtn) {
            authBtn.addEventListener('click', clickButtonLogin )
            // ReactDOM.render(<ReLogin query={queryParams} />, authBtn)
        }

    },[user.unknown_device])

    useEffect(()=>{
        if (localStorage.getItem("_wh_call") !== null) {
            const tmp = JSON.parse(localStorage.getItem("_wh_call"))
            if (tmp.expire < Date.now()/1000) {
                setAuthChallengeRender(true)
                tmp.type === 499 ? setAuthCall499(true) : setAuthCall800(true)
            }
        }
    },[])

    return <div>
        {
            Object.keys(builder.template).length !== 0 &&
                <div className={"main-font-style"}>
                    {
                        builder.template.loader && (
                            <ScriptTag
                                dangerouslySetInnerHTML={{ __html: builder.template.loader.replaceAll('/assets/', `${BE_ADDR}/assets/`) }} />
                        )
                    }
                    <style>
                        {
                            builder.template.css
                                .replaceAll('/assets/', `${BE_ADDR}/assets/`)
                                .replace('/fonts/', `${BE_ADDR}/fonts/`)
                        }
                    </style>
                    {
                        !user.unknown_device
                        
                            ? <div
                                className={`App d-flex flex-column justify-content-between`}
                                id="welcome_block"
                                dangerouslySetInnerHTML={{ __html: builder.template.welcome_block.replaceAll('/assets/', `${BE_ADDR}/assets/`) }}
                            />
                            : <div
                                className={`App d-flex flex-column justify-content-between`}
                                id="auth_block"
                                dangerouslySetInnerHTML={{ __html: builder.template.authentication.replaceAll('/assets/', `${BE_ADDR}/assets/`) }}
                            />
                    }
                </div>
        }
    </div>
}

export default Template